import { ConfigProvider, Table, theme } from 'antd'
import Title from 'antd/lib/typography/Title'
import { FC } from 'react'
import { DESIGNER_SUMMARY_LABELS } from '../constants/designer-summary-labels'
import { DesignerTaskRow } from '../helpers/calc-designer-monthly-stats'
import { columns } from './columns'

interface TasksTableProps {
    rows: DesignerTaskRow[]
    isLoading: boolean
}

const TasksTable: FC<TasksTableProps> = ({ rows, isLoading }) => {
    return (
        <ConfigProvider theme={{ algorithm: theme.compactAlgorithm }}>
            <Table
                title={() => (
                    <Title style={{ marginTop: 0 }} level={5}>
                        {DESIGNER_SUMMARY_LABELS.tasks}
                    </Title>
                )}
                columns={columns}
                dataSource={rows}
                rowKey='key'
                size='small'
                pagination={false}
                loading={isLoading}
            />
        </ConfigProvider>
    )
}

export default TasksTable
